export const getEasiplusFuneralPlan = state => state.easiplusFuneralPlan;
